export { StringCell } from "./StringCell";
export { NumberCell } from "./NumberCell";
export { DateCell } from "./DateCell";
export { CategoryCell } from "./CategoryCell";
export { useCreationModalPending } from "./useCreationModalPending";
export { AccountTypeCell } from "./AccountTypeCell";
export { AccountGroupCell } from "./AccountGroupCell";
export { AccountSubtypeCell } from "./AccountSubtypeCell";
export { AccountSearchCell } from "./AccountSearchCell";
export { AccountClassCell } from "./AccountClassCell";
export { MathCell } from "./MathCell";
export { BooleanCell } from "./BooleanCell";
export { CalculatedAmountCell } from "./CalculatedAmountCell";

export enum CellType {
    ROW_NUMBER = "row_number",
    STRING = "string",
    NUMBER = "number",
    MATH = "math",
    DATE = "date",
    CATEGORY = "category",
    ACCOUNT_TYPE = "account_type",
    ACCOUNT_GROUP = "account_group",
    ACCOUNT_SUBTYPE = "account_subtype",
    ACCOUNT_SEARCH = "account_search",
    ACCOUNT_CLASS = "account_class",
    CLASS = "class",
    COUNTERPARTY = "counterparty",
    ENTITY = "entity",
    FINANCIAL_ACCOUNT = "financial_account",
    LEDGER = "ledger",
    BOOLEAN = "boolean",
}

export interface BaseCellProps<
    V extends string | number | boolean | string[] =
        | string
        | number
        | boolean
        | string[],
> {
    value: V | null;
    onChange: (value: V | null) => void;
    isEditing: boolean;
    removeRow: (idx: number) => void;
    addRow: (idx: number) => void;
    onBlur: () => void;
    inputRef?: React.RefObject<HTMLInputElement | null>;
    finishEditing: (value?: V | null) => void;
    rowIdx: number;
    colId: string;
    row: Record<string, any>;
    enterEditModeKey: string | null;
    showDropdownIndicator?: boolean;
}
